import { Button } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
	color: black;
`;
